import gql from 'graphql-tag';

const brigadasTableQuery = gql`
    query brigadas($numberItems: Int!, $numberPage: Int!, $fieldOrder: String!, $Order: SortOrder!) {
        brigadas(first: $numberItems, page: $numberPage, activo: true, orderBy:[{field: $fieldOrder, order: $Order}]) {
            data {
                id,
                nombre
            }
            paginatorInfo {
                count
                currentPage
                firstItem
                lastItem
                hasMorePages
                lastPage
                perPage
                total
            }
        }
    }
`
const getBrigadas = gql`
    query brigadas($numberItems: Int!, $numberPage: Int!, $fieldOrder: String!, $Order: SortOrder!) {
        brigadas(first: $numberItems, page: $numberPage, activo: true, orderBy:[{field: $fieldOrder, order: $Order}]) {
            data {
                id,
                nombre
            }
            paginatorInfo {
                count
                currentPage
                firstItem
                lastItem
                hasMorePages
                lastPage
                perPage
                total
            }
        }
    }
`

const queries = { brigadasTableQuery, getBrigadas };

export default queries;
